module.exports = __webpack_public_path__ + "img/onetwotree5.d3e2ffc8.jpg";